import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoIcon.module.scss";

const InfoIcon = () => <span className={styles.infoIcon}>i</span>;

const InfoIconWithMessage = ({ message }) => (
  <div className={styles.header}>
    <span className={styles.infoIcon}>i</span>
    <p>
      {message && Array.isArray(message)
        ? message.map((messageItem) => (
            <span key={messageItem}>{messageItem}</span>
          ))
        : message}
    </p>
  </div>
);

InfoIconWithMessage.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.node,
  ]),
};

export { InfoIcon, InfoIconWithMessage };
